import { ScoreModels } from '../results/score-models';
import { SurveyResultsModel } from '../results/survey-results-model';
import { SurveySummaryModel } from '../survey/survey-summary-model';

export interface TrackMyJourneyResultsModel {
  survey: SurveySummaryModel;
  surveyResults: SurveyResultsModel;
  scoreList: ScoreModels;
  disabled?: boolean;
}
